import {Tabs} from '@primer/react-brand'

export const PLAN_TYPES = {
  Individual: 'individual',
  Business: 'business',
} as const

export type PlanType = (typeof PLAN_TYPES)[keyof typeof PLAN_TYPES]

type Props = {
  value: PlanType
  onChange: (value: PlanType) => void
  heading: string
  items: Array<{
    id: string
    value: PlanType
    label: string
  }>
}

export function PlanTypeSegmentedControl(props: Props) {
  const {value, onChange, heading, items} = props

  const activeIndex = items.findIndex(item => item.value === value)

  const handleChange = (activeTab: string) => {
    const nextItem = items[Number(activeTab)]
    if (nextItem) {
      onChange(nextItem.value)
    }
  }

  return (
    <Tabs
      variant="accent"
      align="center"
      aria-label={heading || 'Pricing plans'}
      defaultActiveTab={String(activeIndex < 0 ? 0 : activeIndex)}
      onChange={handleChange}
    >
      {items.map(item => (
        <Tabs.Item key={item.id} id={item.id} aria-controls={`${item.id}-panel`}>
          {item.label}
        </Tabs.Item>
      ))}
    </Tabs>
  )
}
